export class Disk {
  constructor(name = "No Disk", programs = {}, autoRun = false) {
    this.name = name;
    this.programs = programs;
    this.autoRun = autoRun;
  }
}
